var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-controller',{attrs:{"image":_vm.setImage(_vm.image),"cloneable":""},on:{"clone":_vm.edgeAndElement}},[_c('circle-element',{attrs:{"width":100,"height":100}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }